module.exports = __webpack_public_path__ + "img/close-bracket-removebg-preview.43ba7ea2.png";